import React from "react";
import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicTable from "./Tabla";
import CodeContent from "./CodeContent";
import EndpointContent from "./EndpointContent";
import TabLenguaje from './TabLenguaje';
import TablaTipoComprobante from './TablaTipoComprobante';

function createData(
    campo,
    Tipo,
    valorEjemplo,
    Descripcion
) {
    return { campo, Tipo, valorEjemplo, Descripcion };
}

const Recover = () => {
        const [t] = useTranslation('global');
    const code =
        `
    curl --location 'https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1'
    --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd...'
    --header 'Content-Type: application/json'
        `;
    const cCurl =
    `  
        curl --location --request GET 'https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1'
        --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
        --header 'Content-Type: application/json'
        --data '{ ... }'
        `;
    const csRS =
    `   
        var options = new RestClientOptions("")
        {
        MaxTimeout = -1,
        };
        var client = new RestClient(options);
        var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1", Method.Get);
        request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
        request.AddHeader("Content-Type", "application/json");
        var body = @"{ ... }";
        request.AddStringBody(body, DataFormat.Json);
        RestResponse response = await client.ExecuteAsync(request);
        Console.WriteLine(response.Content);
            `;
    const javaOK =
    `        
        OkHttpClient client = new OkHttpClient().newBuilder()
        .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{ ... }");
        Request request = new Request.Builder()
        .url("https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1")
        .method("GET", body)
        .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
        .addHeader("Content-Type", "application/json")
        .build();
        Response response = client.newCall(request).execute();
            `
    ;
    const phpHC =
    `
        <?php
        require_once 'HTTP/Request2.php';
        $request = new HTTP_Request2();
        $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1');
        $request->setMethod(HTTP_Request2::METHOD_GET);
        $request->setConfig(array(
        'follow_redirects' => TRUE
        ));
        $request->setHeader(array(
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
        'Content-Type' => 'application/json'
        ));
        $request->setBody('{ ... }');
        try {
        $response = $request->send();
        if ($response->getStatus() == 200) {
            echo $response->getBody();
        }
        else {
            echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
            $response->getReasonPhrase();
        }
        }
        catch(HTTP_Request2_Exception $e) {
        echo 'Error: ' . $e->getMessage();
        }
    `;
    const csHTC =
    `         
        var client = new HttpClient();
        var request = new HttpRequestMessage(HttpMethod.Get, "https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1");
        request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
        var content = new StringContent("{ ... }", null, "application/json");
        request.Content = content;
        var response = await client.SendAsync(request);
        response.EnsureSuccessStatusCode();
        Console.WriteLine(await response.Content.ReadAsStringAsync());
        `;
    const javaUNI =
    `        
        Unirest.setTimeouts(0, 0);
        HttpResponse<String> response = Unirest.put("https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1")
        .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
        .header("Content-Type", "application/json")
        .body("{}")
        .asString();
    
            `;
    const phpGZ =
    `     
        <?php
        $client = new Client();
        $headers = [
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
        'Content-Type' => 'application/json'
        ];
        $body = '{}';
        $request = new Request('GET', 'https://wsventas-exp.rapifac.com/v0/comprobantes?Id=195097&TipoDocumento=01&Serie=F028&Correlativo=12&TipoDocumentoSig=&Detalles=1&Adicionales=0&Pagos=1', $headers, $body);
        $res = $client->sendAsync($request)->wait();
        echo $res->getBody();
        `;
    const codeResponseFactura =
        `
        {
            "ID": 174876,
            "EsBorrador": false,
            "DocumentoID": "F002-10464",
            "TipoDocumentoCodigo": "01",
            "Serie": "F002",
            "Correlativo": 10464,
            "FechaEmision": "15/01/2024",
            "SeCambiaFecha": false,
            "FechaRegistro": "15/01/2024",
            "TipoOperacionCodigo": "0101",
            "TipoNotaCreditoCodigo": "01",
            "TipoNotaDebitoCodigo": "01",
            "TipoGuiaRemisionCodigo": "",
            "TipoDocumentoCodigoModificado": "01",
            "SerieModificado": "",
            "CorrelativoModificado": "0",
            "FechaEmisionModificado": "",
            "CondicionEstado": "",
            "ImporteTotalTexto": "UN CON 00/100 SOLES",
            "TransferenciaDescripcion": "",
            "PercepcionDescripcion": "",
            "DetraccionDescripcion": "",
            "AmazoniaBienesDescripcion": "",
            "AmazoniaServiciosDescripcion": "",
            "AmazoniaContratosDescripcion": "",
            "CodigoInternoDescripcion": "",
            "EmisorItineranteDescripcion": "",
            "AgenciaPaqueteDescripcion": "",
            "Observacion": "",
            "MonedaCodigo": "PEN",
            "TipoCambio": 3.696,
            "DesdeOrden": false,
            "GuiaNumero": "",
            "DUADAMCodigo": "",
            "ServicioPublicoNumero": "",
            "ServicioPublicoTipo": "",
            "ServicioPublicoCodigo": "",
            "ServicioPublicoCodigoTarifa": "",
            "ReferenciaNumeroDocumento": "",
            "ReferenciaTipoDocumento": "",
            "EmisorDocumento": "",
            "EmisorRuc": "",
            "EmisorNombreComercial": "",
            "EmisorRazonSocial": "",
            "EmisorProvincia": "",
            "EmisorDepartamento": "",
            "EmisorDistrito": "",
            "EmisorUbigeo": "",
            "EmisorCodigoPais": "",
            "EmisorDireccion": "",
            "EmisorAdicionales": null,
            "ClienteTipoDocIdentidadCodigo": "6",
            "ClienteNumeroDocIdentidad": "20406520511",
            "ClienteNombreRazonSocial": "ELECTRONIC MIHABA CORPORATION S.R.L.",
            "ClienteDireccion": "JR. PASCUAL SACO OLIVEROS Nro 873 URB. SANTA CATALINA - LIMA - LIMA - LA VICTORIA",
            "CorreoElectronicoPrincipal": null,
            "ClienteContacto": null,
            "ClienteTelefono": null,
            "ClienteUbigeo": "150115",
            "ClientePaisDocEmisor": "PE",
            "Detraccion": 0.0,
            "DetraccionCuenta": "",
            "DetraccionTipoOperacion": "",
            "DetraccionPorcentaje": 0.0,
            "BienServicioCodigo": "",
            "CondicionPago": "Contado",
            "CreditoTotal": 0.000000,
            "Percepcion": 0.0,
            "PercepcionRegimen": "",
            "PercepcionFactor": 0.0,
            "PercepcionTotal": 0.000000,
            "PercepcionBaseImponible": 0.0,
            "Retencion": 0.0,
            "MontoRetencion": 0.000000,
            "DescuentoGlobal": 0.000000,
            "DescuentoIndicador": false,
            "DescuentoGlobalMonto": 0.000000,
            "DescuentoGlobalMontoBase": 0.000000,
            "DescuentoGlobalPorcentaje": 0.00000,
            "DescuentoGlobalValor": 0.000000,
            "DescuentoGlobalIndicadorDescuento": "",
            "DescuentoGlobalCodigoMotivo": "",
            "DescuentoGlobalNGMonto": 0.000000,
            "DescuentoGlobalNGMontoBase": 1.000000,
            "DescuentoGlobalNGIndicadorDescuento": "",
            "DescuentoGlobalNGCodigoMotivo": "",
            "DescuentoNGMonto": 0.000000,
            "DescuentoGMonto": 0.0,
            "AnticiposGravado": 0.000000,
            "AnticiposExonerado": 0.000000,
            "AnticiposInafecto": 0.000000,
            "AnticipoMonto": 0.0,
            "AnticipoMontoBase": 0.0,
            "AnticipoCodigo": "",
            "CargoGlobalMonto": 0.000000,
            "CargoGlobalMontoBase": 1.000000,
            "CargoGlobalPorcentaje": 0.00000,
            "CargoGlobalIndicadorCargos": "0.000000",
            "CargoGlobalCodigoMotivo": "0",
            "ImpuestoTotal": 0.000000,
            "ISC": 0.000000,
            "ISCBase": 0.000000,
            "IGV": 0.000000,
            "IGVPorcentaje": 10.00000,
            "Gravado": 0.000000,
            "ICBPER": 0.000000,
            "Exonerada": 1.000000,
            "Inafecto": 0.000000,
            "Exportacion": 0.000000,
            "ExoneradaXML": 1.000000,
            "InafectoXML": 0.000000,
            "ExportacionXML": 0.000000,
            "Gratuito": 0.000000,
            "GratuitoGravado": 0.000000,
            "TotalImporteVenta": 1.000000,
            "TotalImporteVentaReferencia": 0.0,
            "TotalPrecioVenta": 1.000000,
            "TotalValorVenta": 1.000000,
            "TotalDescuentos": 0.000000,
            "TotalDescuentosMonto": 0.000000,
            "TotalOtrosCargos": 0.000000,
            "TotalAnticipos": 0.000000,
            "TotalPago": 1.000000,
            "TotalRestante": 1.000000,
            "PendientePago": 1.000000,
            "EnviarCorreo": false,
            "TienePDF": true,
            "TieneXML": true,
            "TieneCDR": true,
            "FormatoPDF": 0,
            "IdRepositorio": 31000443,
            "VistaDocumento": "Wm8lJz3E0zwgA8dPoNoRmg==",
            "SunatRespuesta": "0",
            "SunatMensaje": "La Factura numero F002-10464, ha sido aceptada",
            "Sucursal": 3691,
            "Usuario": "15151515",
            "Vendedor": "15151515",
            "VendedorNombre": "JASON",
            "CanalVenta": "2",
            "AlojamientoTipoDocIdentidadCodigo": "",
            "AlojamientoNumeroDocIdentidad": "",
            "AlojamientoNombreRazonSocial": "",
            "AlojamientoPaisDocEmisor": "",
            "PaisResidencia": "",
            "FechaIngresoPais": null,
            "FechaIngresoEstablecimiento": null,
            "FechaSalidaEstablecimiento": null,
            "FechaConsumo": null,
            "DiasPermanencia": 0,
            "Peso": 0.000000,
            "PesoTotal": 0.000000,
            "Bultos": 1,
            "MotivoTrasladoDescripcion": "",
            "MotivoTrasladoCodigo": "01",
            "ModalidadTrasladoCodigo": "",
            "FechaTraslado": null,
            "RemitenteTipoDocIdentidadCodigo": "",
            "RemitenteNumeroDocIdentidad": "",
            "RemitenteNombreRazonSocial": "",
            "ConductorLicencia": "",
            "TransportistaNumeroDocIdentidad": "",
            "TransportistaNombreRazonSocial": "",
            "TransportistaTipoDocIdentidadCodigo": "",
            "ConductorLicencia2": "",
            "TransportistaNumeroDocIdentidad2": "",
            "TransportistaNombreRazonSocial2": "",
            "TransportistaTipoDocIdentidadCodigo2": "",
            "VehiculoPlaca": "",
            "VehiculoCertificado": "",
            "VehiculoConfiguracion": "",
            "VehiculoAutorizacion": "",
            "VehiculoPlaca2": "",
            "VehiculoCertificado2": "",
            "VehiculoConfiguracion2": "",
            "VehiculoAutorizacion2": "",
            "VehiculoRegistrado": "",
            "VehiculoRegistradoNombre": null,
            "UbigeoLlegada": "",
            "DireccionLlegada": "",
            "NOMBRE_UBIGEOLLEGADA": "",
            "UbigeoPartida": "",
            "DireccionPartida": "",
            "NOMBRE_UBIGEOPARTIDA": "",
            "Anticipo": false,
            "EstadoContingencia": false,
            "Baja": 0,
            "Leyenda": 0,
            "LeyendaBoleta": 0,
            "LeyendaFactura": 3,
            "MotivoBaja": "",
            "OrigenSistema": 0,
            "TipoPrecio": 1,
            "Ubigeo": "150103",
            "Firma": "Mz1+zwLLa2zqLg8e57uu",
            "sIdentificadorBaja": "",
            "sIdentificadorResumen": "",
            "Estado": 0,
            "DocAdicionalCodigo": 1,
            "DocAdicionalDetalle": "",
            "PagosMultiples": false,
            "EsPrico": false,
            "RespuestaURL": "",
            "DetraccionDetalles": "",
            "DetraccionTramoLejano": 0.0,
            "DetraccionTramoCercano": 0.0,
            "DetraccionConfiguracionVehicular": "",
            "DetraccionCargaUtil": 0,
            "DetraccionCargaReal": 0.0,
            "DetraccionFactorReporno": false,
            "DetraccionValorServicioTransporte": 0.0,
            "DetraccionValorCargaEfectiva": 0.0,
            "DetraccionValorCargaUtil": 0.0,
            "RetornoEnvaseVacio": false,
            "CNG": "",
            "ListaDetalles": [
                {
                    "ID": 210824,
                    "Item": 1,
                    "ComprobanteID": 174876,
                    "TipoDocumentoCodigo": "01",
                    "Serie": "F002",
                    "Correlativo": 10464,
                    "TipoProductoCodigo": "1 ",
                    "Observacion": "",
                    "DocumentoID": "F002-10464",
                    "UnidadMedidaCodigo": "NIU",
                    "UnidadMedidaDescripcion": "UNIDAD",
                    "Cantidad": 1.000000,
                    "Descripcion": "1/8 DE POLLO A LA BRASA",
                    "ProductoCodigo": "NAND02",
                    "ProductoCodigoCliente": "NAND02",
                    "ProductoCodigoSUNAT": "41103022",
                    "PrecioUnitario": 1.000000,
                    "ValorUnitario": 1.000000,
                    "ValorUnitarioNeto": 1.000000,
                    "ValorVenta": 1.000000,
                    "PrecioUnitarioItem": 1.000000,
                    "ValorVentaItem": 1.000000,
                    "ValorVentaItemXML": 1.000000,
                    "PrecioUnitarioNeto": 1.000000,
                    "PrecioVenta": 1.000000,
                    "PrecioVentaCodigo": "02",
                    "CantidadUnidadMedida": 1.000000,
                    "Descuento": 0.000000,
                    "DescuentoBase": 1.000000,
                    "DescuentoMonto": 0.0,
                    "DescuentoPorcentaje": 0.00000,
                    "DescuentoIndicador": "0",
                    "DescuentoCargoCodigo": "01",
                    "Cargo": 0.000000,
                    "CargoBase": 0.0,
                    "CargoItem": 0.000000,
                    "CargoPorcentaje": 0.00000,
                    "CargoIndicador": "False",
                    "CargoCodigo": "",
                    "Percepcion": 0.000000,
                    "PercepcionBase": 0.000000,
                    "PercepcionPorcentaje": 0.000000,
                    "PercepcionIndicador": "",
                    "PercepcionCargoCodigo": "",
                    "PercepcionCantidadUmbral": 0.00,
                    "PercepcionMontoUmbral": 0.00,
                    "MontoTributo": 0.000000,
                    "ISC": 0.000000,
                    "ISCBase": 0.0,
                    "ISCPorcentaje": 0.00000,
                    "TipoSistemaISCCodigo": "00",
                    "PrecioUnitarioSugerido": 0.0,
                    "ICBPER": 0.000000,
                    "ICBPECantidad": 0,
                    "ICBPERSubTotal": 0.000000,
                    "TipoAfectacionIGVCodigo": "20",
                    "IGVBase": 0.0,
                    "IGV": 0.000000,
                    "IGVPorcentaje": 0.0,
                    "ImporteTotal": 1.000000,
                    "Kit": false,
                    "PrecioCompra": 1.000000,
                    "PrecioCompra_Base": 29.00000000,
                    "PrecioCompraUSD": 1.000000,
                    "PrecioCompra_BaseUSD": 7.83148800,
                    "Importado": false,
                    "CodigoCategoria": 11,
                    "Peso": 1.000000,
                    "Peso_Base": 0.0,
                    "PesoTotal": 0.000000,
                    "Control": 0,
                    "PrecioCodigo": 0,
                    "Stock": 914.000000,
                    "Vendedor": 0,
                    "ListaSeries": [],
                    "ListaPrecios": [
                        {
                            "PrecioId": 48063,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 1.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48064,
                            "PrecioConfiguracion": 2,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48065,
                            "PrecioConfiguracion": 3,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48066,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 1.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48067,
                            "PrecioConfiguracion": 2,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48068,
                            "PrecioConfiguracion": 3,
                            "ProductoCodigo": "NAND02",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "25/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        }
                    ]
                }
            ],
            "ListaAnticipos": [],
            "ListaCuotas": [],
            "ListaGuias": [],
            "ListaMovimientos": [
                {
                    "IdMovimiento": 94811,
                    "TipoCuentaCodigo": 3,
                    "CuentaNumero": "12547856931",
                    "CuentaNombre": "BCPAAA",
                    "TipoIngresoEgreso": 1,
                    "MontoPagar": 1.000000,
                    "MonedaCodigo": "PEN",
                    "Observacion": "INGRESO VENTAS",
                    "NumeroOperacion": "1324567896",
                    "TipoDocIdentidadCodigo": "6",
                    "NumeroDocIdentidad": "20406520511",
                    "Origen": "VENTAS",
                    "TipoDocumentoCodigo": "01",
                    "Serie": "F002",
                    "Correlativo": 10464,
                    "Usuario": "15151515",
                    "IdOrigen": 1,
                    "Estado": 1,
                    "FechaPago": "15/01/2024",
                    "SucursalId": 0,
                    "Pago": 1.000000,
                    "Pagado": 0.000000,
                    "Saldo": 0.000000,
                    "FechaVencimiento": "01/01/1900",
                    "PlazoDias": 0,
                    "CondicionComprobante": "Contado",
                    "Condicion": "Contado",
                    "Vuelto": 0.0,
                    "CondicionPagoModificado": "",
                    "CuentaNumeroModificado": "",
                    "CuentaTipoModificado": "",
                    "FechaMovimiento": ""
                }
            ],
            "ListaDocumentosRelacionados": [],
            "ListaCondicionesComerciales": null
        }
        `;
        const codeResponseBoleta =
        `
        {
            "ID": 174668,
            "EsBorrador": false,
            "DocumentoID": "B002-2861",
            "TipoDocumentoCodigo": "03",
            "Serie": "B002",
            "Correlativo": 2861,
            "FechaEmision": "03/01/2024",
            "SeCambiaFecha": false,
            "FechaRegistro": "03/01/2024",
            "TipoOperacionCodigo": "0101",
            "TipoNotaCreditoCodigo": "01",
            "TipoNotaDebitoCodigo": "01",
            "TipoGuiaRemisionCodigo": "",
            "TipoDocumentoCodigoModificado": "01",
            "SerieModificado": "",
            "CorrelativoModificado": "0",
            "FechaEmisionModificado": "",
            "CondicionEstado": "",
            "ImporteTotalTexto": "DOSCIENTOS CINCUENTA CON 00/100 SOLES",
            "TransferenciaDescripcion": "",
            "PercepcionDescripcion": "",
            "DetraccionDescripcion": "",
            "AmazoniaBienesDescripcion": "",
            "AmazoniaServiciosDescripcion": "",
            "AmazoniaContratosDescripcion": "",
            "CodigoInternoDescripcion": "",
            "EmisorItineranteDescripcion": "",
            "AgenciaPaqueteDescripcion": "",
            "Observacion": "",
            "MonedaCodigo": "PEN",
            "TipoCambio": 3.713,
            "DesdeOrden": false,
            "GuiaNumero": "",
            "DUADAMCodigo": "",
            "ServicioPublicoNumero": "",
            "ServicioPublicoTipo": "",
            "ServicioPublicoCodigo": "",
            "ServicioPublicoCodigoTarifa": "",
            "ReferenciaNumeroDocumento": "",
            "ReferenciaTipoDocumento": "",
            "EmisorDocumento": "",
            "EmisorRuc": "",
            "EmisorNombreComercial": "",
            "EmisorRazonSocial": "",
            "EmisorProvincia": "",
            "EmisorDepartamento": "",
            "EmisorDistrito": "",
            "EmisorUbigeo": "",
            "EmisorCodigoPais": "",
            "EmisorDireccion": "",
            "EmisorAdicionales": null,
            "ClienteTipoDocIdentidadCodigo": "-",
            "ClienteNumeroDocIdentidad": "10000000",
            "ClienteNombreRazonSocial": "CLIENTES VARIOS",
            "ClienteDireccion": "-",
            "CorreoElectronicoPrincipal": null,
            "ClienteContacto": null,
            "ClienteTelefono": null,
            "ClienteUbigeo": "010100",
            "ClientePaisDocEmisor": "PE",
            "Detraccion": 0.0,
            "DetraccionCuenta": "",
            "DetraccionTipoOperacion": "",
            "DetraccionPorcentaje": 0.0,
            "BienServicioCodigo": "",
            "CondicionPago": "Contado",
            "CreditoTotal": 0.000000,
            "Percepcion": 0.0,
            "PercepcionRegimen": "",
            "PercepcionFactor": 0.0,
            "PercepcionTotal": 0.000000,
            "PercepcionBaseImponible": 0.0,
            "Retencion": 0.0,
            "MontoRetencion": 0.000000,
            "DescuentoGlobal": 211.864406,
            "DescuentoIndicador": false,
            "DescuentoGlobalMonto": 211.864406,
            "DescuentoGlobalMontoBase": 423.728813,
            "DescuentoGlobalPorcentaje": 50.00000,
            "DescuentoGlobalValor": 250.000000,
            "DescuentoGlobalIndicadorDescuento": "",
            "DescuentoGlobalCodigoMotivo": "",
            "DescuentoGlobalNGMonto": 0.000000,
            "DescuentoGlobalNGMontoBase": 0.000000,
            "DescuentoGlobalNGIndicadorDescuento": "",
            "DescuentoGlobalNGCodigoMotivo": "",
            "DescuentoNGMonto": 0.000000,
            "DescuentoGMonto": 0.0,
            "AnticiposGravado": 0.000000,
            "AnticiposExonerado": 0.000000,
            "AnticiposInafecto": 0.000000,
            "AnticipoMonto": 0.0,
            "AnticipoMontoBase": 0.0,
            "AnticipoCodigo": "",
            "CargoGlobalMonto": 0.000000,
            "CargoGlobalMontoBase": 423.728813,
            "CargoGlobalPorcentaje": 0.00000,
            "CargoGlobalIndicadorCargos": "0.000000",
            "CargoGlobalCodigoMotivo": "0",
            "ImpuestoTotal": 38.135593,
            "ISC": 0.000000,
            "ISCBase": 0.000000,
            "IGV": 38.135593,
            "IGVPorcentaje": 18.00000,
            "Gravado": 211.864406,
            "ICBPER": 0.000000,
            "Exonerada": 0.000000,
            "Inafecto": 0.000000,
            "Exportacion": 0.000000,
            "ExoneradaXML": 0.000000,
            "InafectoXML": 0.000000,
            "ExportacionXML": 0.000000,
            "Gratuito": 0.000000,
            "GratuitoGravado": 0.000000,
            "TotalImporteVenta": 250.000000,
            "TotalImporteVentaReferencia": 0.0,
            "TotalPrecioVenta": 250.000000,
            "TotalValorVenta": 211.864406,
            "TotalDescuentos": 211.864406,
            "TotalDescuentosMonto": 250.000000,
            "TotalOtrosCargos": 0.000000,
            "TotalAnticipos": 0.000000,
            "TotalPago": 250.000000,
            "TotalRestante": 250.000000,
            "PendientePago": 250.000000,
            "EnviarCorreo": false,
            "TienePDF": true,
            "TieneXML": true,
            "TieneCDR": true,
            "FormatoPDF": 2,
            "IdRepositorio": 31000125,
            "VistaDocumento": "POkQkiDmVIGsfDC5W9HY+w==",
            "SunatRespuesta": "0",
            "SunatMensaje": "La Boleta numero B002-2861, ha sido aceptada",
            "Sucursal": 3691,
            "Usuario": "99999999",
            "Vendedor": "99999999",
            "VendedorNombre": "JEREMY",
            "CanalVenta": "2",
            "AlojamientoTipoDocIdentidadCodigo": "",
            "AlojamientoNumeroDocIdentidad": "",
            "AlojamientoNombreRazonSocial": "",
            "AlojamientoPaisDocEmisor": "",
            "PaisResidencia": "",
            "FechaIngresoPais": null,
            "FechaIngresoEstablecimiento": null,
            "FechaSalidaEstablecimiento": null,
            "FechaConsumo": null,
            "DiasPermanencia": 0,
            "Peso": 0.000000,
            "PesoTotal": 0.000000,
            "Bultos": 0,
            "MotivoTrasladoDescripcion": "",
            "MotivoTrasladoCodigo": "01",
            "ModalidadTrasladoCodigo": "",
            "FechaTraslado": null,
            "RemitenteTipoDocIdentidadCodigo": "",
            "RemitenteNumeroDocIdentidad": "",
            "RemitenteNombreRazonSocial": "",
            "ConductorLicencia": "",
            "TransportistaNumeroDocIdentidad": "",
            "TransportistaNombreRazonSocial": "",
            "TransportistaTipoDocIdentidadCodigo": "",
            "ConductorLicencia2": "",
            "TransportistaNumeroDocIdentidad2": "",
            "TransportistaNombreRazonSocial2": "",
            "TransportistaTipoDocIdentidadCodigo2": "",
            "VehiculoPlaca": "",
            "VehiculoCertificado": "",
            "VehiculoConfiguracion": "",
            "VehiculoAutorizacion": "",
            "VehiculoPlaca2": "",
            "VehiculoCertificado2": "",
            "VehiculoConfiguracion2": "",
            "VehiculoAutorizacion2": "",
            "VehiculoRegistrado": "",
            "VehiculoRegistradoNombre": null,
            "UbigeoLlegada": "",
            "DireccionLlegada": "",
            "NOMBRE_UBIGEOLLEGADA": "",
            "UbigeoPartida": "",
            "DireccionPartida": "",
            "NOMBRE_UBIGEOPARTIDA": "",
            "Anticipo": false,
            "EstadoContingencia": false,
            "Baja": 0,
            "Leyenda": 0,
            "LeyendaBoleta": 0,
            "LeyendaFactura": 0,
            "MotivoBaja": "",
            "OrigenSistema": 3,
            "TipoPrecio": 0,
            "Ubigeo": "150103",
            "Firma": "SGDvOeChTG4s8dVAtE+v",
            "sIdentificadorBaja": "",
            "sIdentificadorResumen": "",
            "Estado": 0,
            "DocAdicionalCodigo": 0,
            "DocAdicionalDetalle": "",
            "PagosMultiples": false,
            "EsPrico": false,
            "RespuestaURL": "",
            "DetraccionDetalles": "",
            "DetraccionTramoLejano": 0.0,
            "DetraccionTramoCercano": 0.0,
            "DetraccionConfiguracionVehicular": "",
            "DetraccionCargaUtil": 0,
            "DetraccionCargaReal": 0.0,
            "DetraccionFactorReporno": false,
            "DetraccionValorServicioTransporte": 0.0,
            "DetraccionValorCargaEfectiva": 0.0,
            "DetraccionValorCargaUtil": 0.0,
            "RetornoEnvaseVacio": false,
            "CNG": "",
            "ListaDetalles": [
                {
                    "ID": 210250,
                    "Item": 1,
                    "ComprobanteID": 174668,
                    "TipoDocumentoCodigo": "03",
                    "Serie": "B002",
                    "Correlativo": 2861,
                    "TipoProductoCodigo": "1 ",
                    "Observacion": "",
                    "DocumentoID": "B002-2861",
                    "UnidadMedidaCodigo": "GLI",
                    "UnidadMedidaDescripcion": "GALON",
                    "Cantidad": 50.000000,
                    "Descripcion": "GASOHOL 84",
                    "ProductoCodigo": "G84",
                    "ProductoCodigoCliente": "G84",
                    "ProductoCodigoSUNAT": "56112005",
                    "PrecioUnitario": 10.000000,
                    "ValorUnitario": 8.474576,
                    "ValorUnitarioNeto": 4.237288,
                    "ValorVenta": 423.728813,
                    "PrecioUnitarioItem": 10.000000,
                    "ValorVentaItem": 423.728813,
                    "ValorVentaItemXML": 423.728813,
                    "PrecioUnitarioNeto": 5.000000,
                    "PrecioVenta": 500.000000,
                    "PrecioVentaCodigo": "01",
                    "CantidadUnidadMedida": 1.000000,
                    "Descuento": 0.000000,
                    "DescuentoBase": 423.728813,
                    "DescuentoMonto": 0.0,
                    "DescuentoPorcentaje": 0.00000,
                    "DescuentoIndicador": "0",
                    "DescuentoCargoCodigo": "00",
                    "Cargo": 0.000000,
                    "CargoBase": 0.0,
                    "CargoItem": 0.000000,
                    "CargoPorcentaje": 0.00000,
                    "CargoIndicador": "False",
                    "CargoCodigo": "",
                    "Percepcion": 0.000000,
                    "PercepcionBase": 0.000000,
                    "PercepcionPorcentaje": 0.000000,
                    "PercepcionIndicador": "",
                    "PercepcionCargoCodigo": "",
                    "PercepcionCantidadUmbral": 0.00,
                    "PercepcionMontoUmbral": 0.00,
                    "MontoTributo": 76.271186,
                    "ISC": 0.000000,
                    "ISCBase": 0.0,
                    "ISCPorcentaje": 0.00000,
                    "TipoSistemaISCCodigo": "00",
                    "PrecioUnitarioSugerido": 0.0,
                    "ICBPER": 0.000000,
                    "ICBPECantidad": 0,
                    "ICBPERSubTotal": 0.000000,
                    "TipoAfectacionIGVCodigo": "10",
                    "IGVBase": 0.0,
                    "IGV": 76.271186,
                    "IGVPorcentaje": 0.0,
                    "ImporteTotal": 500.000000,
                    "Kit": false,
                    "PrecioCompra": 0.000000,
                    "PrecioCompra_Base": 0.00000000,
                    "PrecioCompraUSD": 0.000000,
                    "PrecioCompra_BaseUSD": 0.00000000,
                    "Importado": false,
                    "CodigoCategoria": 40,
                    "Peso": 1.000000,
                    "Peso_Base": 0.0,
                    "PesoTotal": 0.000000,
                    "Control": 0,
                    "PrecioCodigo": 0,
                    "Stock": -6.333333,
                    "Vendedor": 0,
                    "ListaSeries": [],
                    "ListaPrecios": [
                        {
                            "PrecioId": 48477,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 30.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48478,
                            "PrecioConfiguracion": 2,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 25.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48479,
                            "PrecioConfiguracion": 3,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 20.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48480,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48481,
                            "PrecioConfiguracion": 2,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        },
                        {
                            "PrecioId": 48482,
                            "PrecioConfiguracion": 3,
                            "ProductoCodigo": "G84",
                            "CodigoUnidadMedida": "GLI",
                            "DescripcionUnidadMedida": "GALON",
                            "CantidadUnidadMedida": 1.000000,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.000000,
                            "MargenPorcentaje": 0.000000,
                            "PrecioVenta": 0.000000,
                            "Sugerido": 0.000000,
                            "OtrosCargosPorcentaje": 0.000000,
                            "CantidadAplicable": 0.000000,
                            "FechaIngreso": "25/01/2024",
                            "FechaActualizacion": "26/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.000000,
                            "ISCCalculado": 0.000000
                        }
                    ]
                }
            ],
            "ListaAnticipos": [],
            "ListaCuotas": [],
            "ListaGuias": [],
            "ListaMovimientos": [
                {
                    "IdMovimiento": 94040,
                    "TipoCuentaCodigo": 1,
                    "CuentaNumero": "99999999",
                    "CuentaNombre": "JEREMY",
                    "TipoIngresoEgreso": 1,
                    "MontoPagar": 250.000000,
                    "MonedaCodigo": "PEN",
                    "Observacion": "INGRESO VENTAS",
                    "NumeroOperacion": "",
                    "TipoDocIdentidadCodigo": "-",
                    "NumeroDocIdentidad": "10000000",
                    "Origen": "VENTAS",
                    "TipoDocumentoCodigo": "03",
                    "Serie": "B002",
                    "Correlativo": 2861,
                    "Usuario": "99999999",
                    "IdOrigen": 1,
                    "Estado": 1,
                    "FechaPago": "03/01/2024",
                    "SucursalId": 3691,
                    "Pago": 250.000000,
                    "Pagado": 0.000000,
                    "Saldo": 0.000000,
                    "FechaVencimiento": "01/01/1900",
                    "PlazoDias": 0,
                    "CondicionComprobante": "Contado",
                    "Condicion": "Contado",
                    "Vuelto": 0.0,
                    "CondicionPagoModificado": "",
                    "CuentaNumeroModificado": "",
                    "CuentaTipoModificado": "",
                    "FechaMovimiento": ""
                }
            ],
            "ListaDocumentosRelacionados": [],
            "ListaCondicionesComerciales": null
        }
        `;
        const codeResponseNotaCredito =
        `
        {
            "ID": 174795,
            "EsBorrador": false,
            "DocumentoID": "FC02-550",
            "TipoDocumentoCodigo": "07",
            "Serie": "FC02",
            "Correlativo": 550,
            "FechaEmision": "11/01/2024",
            "SeCambiaFecha": false,
            "FechaRegistro": "11/01/2024",
            "TipoOperacionCodigo": "0101",
            "TipoNotaCreditoCodigo": "04",
            "TipoNotaDebitoCodigo": "01",
            "TipoGuiaRemisionCodigo": "",
            "TipoDocumentoCodigoModificado": "01",
            "SerieModificado": "F002",
            "CorrelativoModificado": "10453",
            "FechaEmisionModificado": "",
            "CondicionEstado": "",
            "ImporteTotalTexto": "CIEN CON 00/100 SOLES",
            "TransferenciaDescripcion": "",
            "PercepcionDescripcion": "",
            "DetraccionDescripcion": "",
            "AmazoniaBienesDescripcion": "",
            "AmazoniaServiciosDescripcion": "",
            "AmazoniaContratosDescripcion": "",
            "CodigoInternoDescripcion": "",
            "EmisorItineranteDescripcion": "",
            "AgenciaPaqueteDescripcion": "",
            "Observacion": "DESCUENTO GLOBAL",
            "MonedaCodigo": "PEN",
            "TipoCambio": 3.704,
            "DesdeOrden": false,
            "GuiaNumero": "",
            "DUADAMCodigo": "",
            "ServicioPublicoNumero": "",
            "ServicioPublicoTipo": "",
            "ServicioPublicoCodigo": "",
            "ServicioPublicoCodigoTarifa": "",
            "ReferenciaNumeroDocumento": "",
            "ReferenciaTipoDocumento": "",
            "EmisorDocumento": "",
            "EmisorRuc": "",
            "EmisorNombreComercial": "",
            "EmisorRazonSocial": "",
            "EmisorProvincia": "",
            "EmisorDepartamento": "",
            "EmisorDistrito": "",
            "EmisorUbigeo": "",
            "EmisorCodigoPais": "",
            "EmisorDireccion": "",
            "EmisorAdicionales": null,
            "ClienteTipoDocIdentidadCodigo": "6",
            "ClienteNumeroDocIdentidad": "20600598334",
            "ClienteNombreRazonSocial": "RAPIFAC SOCIEDAD ANONIMA - RAPIFAC S.A.",
            "ClienteDireccion": "CAL. HIPOLITO UNANUE Mz. B Lt. 1 URB. LAS MALVINAS - CUSCO - CUSCO - SANTIAGO",
            "CorreoElectronicoPrincipal": null,
            "ClienteContacto": null,
            "ClienteTelefono": null,
            "ClienteUbigeo": "080106",
            "ClientePaisDocEmisor": "PE",
            "Detraccion": 0.0,
            "DetraccionCuenta": "",
            "DetraccionTipoOperacion": "",
            "DetraccionPorcentaje": 0.0,
            "BienServicioCodigo": "",
            "CondicionPago": "Contado",
            "CreditoTotal": 0.000000,
            "Percepcion": 0.0,
            "PercepcionRegimen": "",
            "PercepcionFactor": 0.0,
            "PercepcionTotal": 0.000000,
            "PercepcionBaseImponible": 0.0,
            "Retencion": 0.0,
            "MontoRetencion": 0.000000,
            "DescuentoGlobal": 0.000000,
            "DescuentoIndicador": false,
            "DescuentoGlobalMonto": 0.000000,
            "DescuentoGlobalMontoBase": 84.745762,
            "DescuentoGlobalPorcentaje": 0.00000,
            "DescuentoGlobalValor": 0.000000,
            "DescuentoGlobalIndicadorDescuento": "",
            "DescuentoGlobalCodigoMotivo": "",
            "DescuentoGlobalNGMonto": 0.000000,
            "DescuentoGlobalNGMontoBase": 0.000000,
            "DescuentoGlobalNGIndicadorDescuento": "",
            "DescuentoGlobalNGCodigoMotivo": "",
            "DescuentoNGMonto": 0.000000,
            "DescuentoGMonto": 0.0,
            "AnticiposGravado": 0.000000,
            "AnticiposExonerado": 0.000000,
            "AnticiposInafecto": 0.000000,
            "AnticipoMonto": 0.0,
            "AnticipoMontoBase": 0.0,
            "AnticipoCodigo": "",
            "CargoGlobalMonto": 0.000000,
            "CargoGlobalMontoBase": 84.745762,
            "CargoGlobalPorcentaje": 0.00000,
            "CargoGlobalIndicadorCargos": "0.000000",
            "CargoGlobalCodigoMotivo": "0",
            "ImpuestoTotal": 15.254237,
            "ISC": 0.000000,
            "ISCBase": 0.000000,
            "IGV": 15.254237,
            "IGVPorcentaje": 18.00000,
            "Gravado": 84.745762,
            "ICBPER": 0.000000,
            "Exonerada": 0.000000,
            "Inafecto": 0.000000,
            "Exportacion": 0.000000,
            "ExoneradaXML": 0.000000,
            "InafectoXML": 0.000000,
            "ExportacionXML": 0.000000,
            "Gratuito": 0.000000,
            "GratuitoGravado": 0.000000,
            "TotalImporteVenta": 100.000000,
            "TotalImporteVentaReferencia": 0.0,
            "TotalPrecioVenta": 100.000000,
            "TotalValorVenta": 84.745762,
            "TotalDescuentos": 0.000000,
            "TotalDescuentosMonto": 0.000000,
            "TotalOtrosCargos": 0.000000,
            "TotalAnticipos": 0.000000,
            "TotalPago": 100.000000,
            "TotalRestante": 100.000000,
            "PendientePago": 100.000000,
            "EnviarCorreo": false,
            "TienePDF": true,
            "TieneXML": true,
            "TieneCDR": true,
            "FormatoPDF": 0,
            "IdRepositorio": 31000318,
            "VistaDocumento": "Bp2jXclB9pUMwfuneMLVLw==",
            "SunatRespuesta": "0",
            "SunatMensaje": "La Nota de Credito numero FC02-550, ha sido aceptada",
            "Sucursal": 3691,
            "Usuario": "41414141",
            "Vendedor": "41414141",
            "VendedorNombre": "NURIA",
            "CanalVenta": "2",
            "AlojamientoTipoDocIdentidadCodigo": "",
            "AlojamientoNumeroDocIdentidad": "",
            "AlojamientoNombreRazonSocial": "",
            "AlojamientoPaisDocEmisor": "",
            "PaisResidencia": "",
            "FechaIngresoPais": null,
            "FechaIngresoEstablecimiento": null,
            "FechaSalidaEstablecimiento": null,
            "FechaConsumo": null,
            "DiasPermanencia": 0,
            "Peso": 0.000000,
            "PesoTotal": 0.000000,
            "Bultos": 1,
            "MotivoTrasladoDescripcion": "",
            "MotivoTrasladoCodigo": "01",
            "ModalidadTrasladoCodigo": "",
            "FechaTraslado": null,
            "RemitenteTipoDocIdentidadCodigo": "",
            "RemitenteNumeroDocIdentidad": "",
            "RemitenteNombreRazonSocial": "",
            "ConductorLicencia": "",
            "TransportistaNumeroDocIdentidad": "",
            "TransportistaNombreRazonSocial": "",
            "TransportistaTipoDocIdentidadCodigo": "",
            "ConductorLicencia2": "",
            "TransportistaNumeroDocIdentidad2": "",
            "TransportistaNombreRazonSocial2": "",
            "TransportistaTipoDocIdentidadCodigo2": "",
            "VehiculoPlaca": "",
            "VehiculoCertificado": "",
            "VehiculoConfiguracion": "",
            "VehiculoAutorizacion": "",
            "VehiculoPlaca2": "",
            "VehiculoCertificado2": "",
            "VehiculoConfiguracion2": "",
            "VehiculoAutorizacion2": "",
            "VehiculoRegistrado": "",
            "VehiculoRegistradoNombre": null,
            "UbigeoLlegada": "",
            "DireccionLlegada": "",
            "NOMBRE_UBIGEOLLEGADA": "",
            "UbigeoPartida": "",
            "DireccionPartida": "",
            "NOMBRE_UBIGEOPARTIDA": "",
            "Anticipo": false,
            "EstadoContingencia": false,
            "Baja": 0,
            "Leyenda": 0,
            "LeyendaBoleta": 0,
            "LeyendaFactura": 0,
            "MotivoBaja": "",
            "OrigenSistema": 0,
            "TipoPrecio": 0,
            "Ubigeo": "150103",
            "Firma": "DSuI+nbznLsZo8OwewV0",
            "sIdentificadorBaja": "",
            "sIdentificadorResumen": "",
            "Estado": 0,
            "DocAdicionalCodigo": 1,
            "DocAdicionalDetalle": "",
            "PagosMultiples": false,
            "EsPrico": false,
            "RespuestaURL": "",
            "DetraccionDetalles": "",
            "DetraccionTramoLejano": 0.0,
            "DetraccionTramoCercano": 0.0,
            "DetraccionConfiguracionVehicular": "",
            "DetraccionCargaUtil": 0,
            "DetraccionCargaReal": 0.0,
            "DetraccionFactorReporno": false,
            "DetraccionValorServicioTransporte": 0.0,
            "DetraccionValorCargaEfectiva": 0.0,
            "DetraccionValorCargaUtil": 0.0,
            "RetornoEnvaseVacio": false,
            "CNG": "",
            "ListaDetalles": [
                {
                    "ID": 210680,
                    "Item": 1,
                    "ComprobanteID": 174795,
                    "TipoDocumentoCodigo": "07",
                    "Serie": "FC02",
                    "Correlativo": 550,
                    "TipoProductoCodigo": "1 ",
                    "Observacion": "",
                    "DocumentoID": "FC02-550",
                    "UnidadMedidaCodigo": "NIU",
                    "UnidadMedidaDescripcion": "UNIDAD",
                    "Cantidad": 1.000000,
                    "Descripcion": "DESCUENTO GLOBAL",
                    "ProductoCodigo": "Prod00000",
                    "ProductoCodigoCliente": "",
                    "ProductoCodigoSUNAT": "Prod00000",
                    "PrecioUnitario": 100.000000,
                    "ValorUnitario": 84.745762,
                    "ValorUnitarioNeto": 84.745762,
                    "ValorVenta": 84.745762,
                    "PrecioUnitarioItem": 100.000000,
                    "ValorVentaItem": 84.745762,
                    "ValorVentaItemXML": 84.745762,
                    "PrecioUnitarioNeto": 100.000000,
                    "PrecioVenta": 100.000000,
                    "PrecioVentaCodigo": "01",
                    "CantidadUnidadMedida": 1.000000,
                    "Descuento": 0.000000,
                    "DescuentoBase": 84.745762,
                    "DescuentoMonto": 0.0,
                    "DescuentoPorcentaje": 0.00000,
                    "DescuentoIndicador": "1",
                    "DescuentoCargoCodigo": "00",
                    "Cargo": 0.000000,
                    "CargoBase": 0.0,
                    "CargoItem": 0.000000,
                    "CargoPorcentaje": 0.00000,
                    "CargoIndicador": "True",
                    "CargoCodigo": "",
                    "Percepcion": 0.000000,
                    "PercepcionBase": 0.000000,
                    "PercepcionPorcentaje": 0.000000,
                    "PercepcionIndicador": "",
                    "PercepcionCargoCodigo": "",
                    "PercepcionCantidadUmbral": 0.00,
                    "PercepcionMontoUmbral": 0.00,
                    "MontoTributo": 15.254237,
                    "ISC": 0.000000,
                    "ISCBase": 0.0,
                    "ISCPorcentaje": 0.00000,
                    "TipoSistemaISCCodigo": "00",
                    "PrecioUnitarioSugerido": 0.0,
                    "ICBPER": 0.000000,
                    "ICBPECantidad": 0,
                    "ICBPERSubTotal": 0.000000,
                    "TipoAfectacionIGVCodigo": "10",
                    "IGVBase": 0.0,
                    "IGV": 15.254237,
                    "IGVPorcentaje": 0.0,
                    "ImporteTotal": 100.000000,
                    "Kit": true,
                    "PrecioCompra": 0.000000,
                    "PrecioCompra_Base": 0.00000000,
                    "PrecioCompraUSD": 0.000000,
                    "PrecioCompra_BaseUSD": 0.00000000,
                    "Importado": false,
                    "CodigoCategoria": 0,
                    "Peso": 1.000000,
                    "Peso_Base": 0.0,
                    "PesoTotal": 0.000000,
                    "Control": 0,
                    "PrecioCodigo": 0,
                    "Stock": 0.000000,
                    "Vendedor": 0,
                    "ListaSeries": [],
                    "ListaPrecios": [
                        {
                            "PrecioId": -1,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "Prod00000",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.0,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.0,
                            "MargenPorcentaje": 0.0,
                            "PrecioVenta": 100.000000,
                            "Sugerido": 0.0,
                            "OtrosCargosPorcentaje": 0.0,
                            "CantidadAplicable": 0.0,
                            "FechaIngreso": "29/01/2024",
                            "FechaActualizacion": "29/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.0,
                            "ISCCalculado": 0.0
                        },
                        {
                            "PrecioId": -2,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "Prod00000",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.0,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.0,
                            "MargenPorcentaje": 0.0,
                            "PrecioVenta": 100.000000,
                            "Sugerido": 0.0,
                            "OtrosCargosPorcentaje": 0.0,
                            "CantidadAplicable": 0.0,
                            "FechaIngreso": "29/01/2024",
                            "FechaActualizacion": "29/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.0,
                            "ISCCalculado": 0.0
                        }
                    ]
                }
            ],
            "ListaAnticipos": [],
            "ListaCuotas": [],
            "ListaGuias": [],
            "ListaMovimientos": [],
            "ListaDocumentosRelacionados": [
                {
                    "ID": 0,
                    "Relacion": 3081,
                    "TipoDocumentoCodigo": "01",
                    "Serie": "F002",
                    "Correlativo": 10452,
                    "FechaEmision": "2024-01-10T00:00:00",
                    "Moneda": "PEN",
                    "Importe": 15.000000,
                    "UsuarioNombre": "JEREMY",
                    "IDPadre": "",
                    "PDF": "Q2mkUtI/WE+/Zn2WvZvDMQ==",
                    "Baja": false
                },
                {
                    "ID": 0,
                    "Relacion": 3081,
                    "TipoDocumentoCodigo": "01",
                    "Serie": "F002",
                    "Correlativo": 10453,
                    "FechaEmision": "2024-11-01T00:00:00",
                    "Moneda": "PEN",
                    "Importe": 1000.000000,
                    "UsuarioNombre": "NURIA",
                    "IDPadre": "",
                    "PDF": "Rhd8dRj9maaldGNbXuRAMQ==",
                    "Baja": false
                }
            ],
            "ListaCondicionesComerciales": null
        }
        `;
        const codeResponseNotaDebito =
        `
        {
            "ID": 174753,
            "EsBorrador": false,
            "DocumentoID": "FD02-31",
            "TipoDocumentoCodigo": "08",
            "Serie": "FD02",
            "Correlativo": 31,
            "FechaEmision": "08/01/2024",
            "SeCambiaFecha": false,
            "FechaRegistro": "08/01/2024",
            "TipoOperacionCodigo": "0101",
            "TipoNotaCreditoCodigo": "01",
            "TipoNotaDebitoCodigo": "01",
            "TipoGuiaRemisionCodigo": "",
            "TipoDocumentoCodigoModificado": "01",
            "SerieModificado": "F002",
            "CorrelativoModificado": "10444",
            "FechaEmisionModificado": "",
            "CondicionEstado": "",
            "ImporteTotalTexto": "CIEN CON 00/100 SOLES",
            "TransferenciaDescripcion": "",
            "PercepcionDescripcion": "",
            "DetraccionDescripcion": "",
            "AmazoniaBienesDescripcion": "",
            "AmazoniaServiciosDescripcion": "",
            "AmazoniaContratosDescripcion": "",
            "CodigoInternoDescripcion": "",
            "EmisorItineranteDescripcion": "",
            "AgenciaPaqueteDescripcion": "",
            "Observacion": "INTERESES POR MORA",
            "MonedaCodigo": "PEN",
            "TipoCambio": 3.723,
            "DesdeOrden": false,
            "GuiaNumero": "",
            "DUADAMCodigo": "",
            "ServicioPublicoNumero": "",
            "ServicioPublicoTipo": "",
            "ServicioPublicoCodigo": "",
            "ServicioPublicoCodigoTarifa": "",
            "ReferenciaNumeroDocumento": "",
            "ReferenciaTipoDocumento": "",
            "EmisorDocumento": "",
            "EmisorRuc": "",
            "EmisorNombreComercial": "",
            "EmisorRazonSocial": "",
            "EmisorProvincia": "",
            "EmisorDepartamento": "",
            "EmisorDistrito": "",
            "EmisorUbigeo": "",
            "EmisorCodigoPais": "",
            "EmisorDireccion": "",
            "EmisorAdicionales": null,
            "ClienteTipoDocIdentidadCodigo": "6",
            "ClienteNumeroDocIdentidad": "10455897012",
            "ClienteNombreRazonSocial": "CORDOVA CARRION PERCY",
            "ClienteDireccion": "-",
            "CorreoElectronicoPrincipal": null,
            "ClienteContacto": null,
            "ClienteTelefono": null,
            "ClienteUbigeo": "150136",
            "ClientePaisDocEmisor": "PE",
            "Detraccion": 0.0,
            "DetraccionCuenta": "",
            "DetraccionTipoOperacion": "",
            "DetraccionPorcentaje": 0.0,
            "BienServicioCodigo": "",
            "CondicionPago": "Contado",
            "CreditoTotal": 0.000000,
            "Percepcion": 0.0,
            "PercepcionRegimen": "",
            "PercepcionFactor": 0.0,
            "PercepcionTotal": 0.000000,
            "PercepcionBaseImponible": 0.0,
            "Retencion": 0.0,
            "MontoRetencion": 0.000000,
            "DescuentoGlobal": 0.000000,
            "DescuentoIndicador": false,
            "DescuentoGlobalMonto": 0.000000,
            "DescuentoGlobalMontoBase": 0.000000,
            "DescuentoGlobalPorcentaje": 0.00000,
            "DescuentoGlobalValor": 0.000000,
            "DescuentoGlobalIndicadorDescuento": "",
            "DescuentoGlobalCodigoMotivo": "",
            "DescuentoGlobalNGMonto": 0.000000,
            "DescuentoGlobalNGMontoBase": 100.000000,
            "DescuentoGlobalNGIndicadorDescuento": "",
            "DescuentoGlobalNGCodigoMotivo": "",
            "DescuentoNGMonto": 0.000000,
            "DescuentoGMonto": 0.0,
            "AnticiposGravado": 0.000000,
            "AnticiposExonerado": 0.000000,
            "AnticiposInafecto": 0.000000,
            "AnticipoMonto": 0.0,
            "AnticipoMontoBase": 0.0,
            "AnticipoCodigo": "",
            "CargoGlobalMonto": 0.000000,
            "CargoGlobalMontoBase": 100.000000,
            "CargoGlobalPorcentaje": 0.00000,
            "CargoGlobalIndicadorCargos": "0.000000",
            "CargoGlobalCodigoMotivo": "0",
            "ImpuestoTotal": 0.000000,
            "ISC": 0.000000,
            "ISCBase": 0.000000,
            "IGV": 0.000000,
            "IGVPorcentaje": 18.00000,
            "Gravado": 0.000000,
            "ICBPER": 0.000000,
            "Exonerada": 0.000000,
            "Inafecto": 100.000000,
            "Exportacion": 0.000000,
            "ExoneradaXML": 0.000000,
            "InafectoXML": 100.000000,
            "ExportacionXML": 0.000000,
            "Gratuito": 0.000000,
            "GratuitoGravado": 0.000000,
            "TotalImporteVenta": 100.000000,
            "TotalImporteVentaReferencia": 0.0,
            "TotalPrecioVenta": 100.000000,
            "TotalValorVenta": 100.000000,
            "TotalDescuentos": 0.000000,
            "TotalDescuentosMonto": 0.000000,
            "TotalOtrosCargos": 0.000000,
            "TotalAnticipos": 0.000000,
            "TotalPago": 100.000000,
            "TotalRestante": 100.000000,
            "PendientePago": 100.000000,
            "EnviarCorreo": false,
            "TienePDF": true,
            "TieneXML": true,
            "TieneCDR": true,
            "FormatoPDF": 0,
            "IdRepositorio": 31000234,
            "VistaDocumento": "fgWSEGB88Lgmc1eh59sX3g==",
            "SunatRespuesta": "0",
            "SunatMensaje": "La Nota de Debito numero FD02-31, ha sido aceptada",
            "Sucursal": 3691,
            "Usuario": "41414141",
            "Vendedor": "41414141",
            "VendedorNombre": "NURIA",
            "CanalVenta": "2",
            "AlojamientoTipoDocIdentidadCodigo": "",
            "AlojamientoNumeroDocIdentidad": "",
            "AlojamientoNombreRazonSocial": "",
            "AlojamientoPaisDocEmisor": "",
            "PaisResidencia": "",
            "FechaIngresoPais": null,
            "FechaIngresoEstablecimiento": null,
            "FechaSalidaEstablecimiento": null,
            "FechaConsumo": null,
            "DiasPermanencia": 0,
            "Peso": 0.000000,
            "PesoTotal": 0.000000,
            "Bultos": 1,
            "MotivoTrasladoDescripcion": "",
            "MotivoTrasladoCodigo": "01",
            "ModalidadTrasladoCodigo": "",
            "FechaTraslado": null,
            "RemitenteTipoDocIdentidadCodigo": "",
            "RemitenteNumeroDocIdentidad": "",
            "RemitenteNombreRazonSocial": "",
            "ConductorLicencia": "",
            "TransportistaNumeroDocIdentidad": "",
            "TransportistaNombreRazonSocial": "",
            "TransportistaTipoDocIdentidadCodigo": "",
            "ConductorLicencia2": "",
            "TransportistaNumeroDocIdentidad2": "",
            "TransportistaNombreRazonSocial2": "",
            "TransportistaTipoDocIdentidadCodigo2": "",
            "VehiculoPlaca": "",
            "VehiculoCertificado": "",
            "VehiculoConfiguracion": "",
            "VehiculoAutorizacion": "",
            "VehiculoPlaca2": "",
            "VehiculoCertificado2": "",
            "VehiculoConfiguracion2": "",
            "VehiculoAutorizacion2": "",
            "VehiculoRegistrado": "",
            "VehiculoRegistradoNombre": null,
            "UbigeoLlegada": "",
            "DireccionLlegada": "",
            "NOMBRE_UBIGEOLLEGADA": "",
            "UbigeoPartida": "",
            "DireccionPartida": "",
            "NOMBRE_UBIGEOPARTIDA": "",
            "Anticipo": false,
            "EstadoContingencia": false,
            "Baja": 0,
            "Leyenda": 0,
            "LeyendaBoleta": 0,
            "LeyendaFactura": 0,
            "MotivoBaja": "",
            "OrigenSistema": 0,
            "TipoPrecio": 0,
            "Ubigeo": "150103",
            "Firma": "0jRavd131bfBtbldU8QC",
            "sIdentificadorBaja": "",
            "sIdentificadorResumen": "",
            "Estado": 0,
            "DocAdicionalCodigo": 1,
            "DocAdicionalDetalle": "",
            "PagosMultiples": false,
            "EsPrico": false,
            "RespuestaURL": "",
            "DetraccionDetalles": "",
            "DetraccionTramoLejano": 0.0,
            "DetraccionTramoCercano": 0.0,
            "DetraccionConfiguracionVehicular": "",
            "DetraccionCargaUtil": 0,
            "DetraccionCargaReal": 0.0,
            "DetraccionFactorReporno": false,
            "DetraccionValorServicioTransporte": 0.0,
            "DetraccionValorCargaEfectiva": 0.0,
            "DetraccionValorCargaUtil": 0.0,
            "RetornoEnvaseVacio": false,
            "CNG": "",
            "ListaDetalles": [
                {
                    "ID": 210626,
                    "Item": 1,
                    "ComprobanteID": 174753,
                    "TipoDocumentoCodigo": "08",
                    "Serie": "FD02",
                    "Correlativo": 31,
                    "TipoProductoCodigo": "1 ",
                    "Observacion": "",
                    "DocumentoID": "FD02-31",
                    "UnidadMedidaCodigo": "NIU",
                    "UnidadMedidaDescripcion": "UNIDAD",
                    "Cantidad": 1.000000,
                    "Descripcion": "INTERESES POR MORA",
                    "ProductoCodigo": "Prod00000",
                    "ProductoCodigoCliente": "",
                    "ProductoCodigoSUNAT": "Prod00000",
                    "PrecioUnitario": 100.000000,
                    "ValorUnitario": 100.000000,
                    "ValorUnitarioNeto": 100.000000,
                    "ValorVenta": 100.000000,
                    "PrecioUnitarioItem": 100.000000,
                    "ValorVentaItem": 100.000000,
                    "ValorVentaItemXML": 100.000000,
                    "PrecioUnitarioNeto": 100.000000,
                    "PrecioVenta": 100.000000,
                    "PrecioVentaCodigo": "01",
                    "CantidadUnidadMedida": 1.000000,
                    "Descuento": 0.000000,
                    "DescuentoBase": 100.000000,
                    "DescuentoMonto": 0.0,
                    "DescuentoPorcentaje": 0.00000,
                    "DescuentoIndicador": "1",
                    "DescuentoCargoCodigo": "01",
                    "Cargo": 0.000000,
                    "CargoBase": 0.0,
                    "CargoItem": 0.000000,
                    "CargoPorcentaje": 0.00000,
                    "CargoIndicador": "True",
                    "CargoCodigo": "",
                    "Percepcion": 0.000000,
                    "PercepcionBase": 0.000000,
                    "PercepcionPorcentaje": 0.000000,
                    "PercepcionIndicador": "",
                    "PercepcionCargoCodigo": "",
                    "PercepcionCantidadUmbral": 0.00,
                    "PercepcionMontoUmbral": 0.00,
                    "MontoTributo": 0.000000,
                    "ISC": 0.000000,
                    "ISCBase": 0.0,
                    "ISCPorcentaje": 0.00000,
                    "TipoSistemaISCCodigo": "00",
                    "PrecioUnitarioSugerido": 0.0,
                    "ICBPER": 0.000000,
                    "ICBPECantidad": 0,
                    "ICBPERSubTotal": 0.000000,
                    "TipoAfectacionIGVCodigo": "30",
                    "IGVBase": 0.0,
                    "IGV": 0.000000,
                    "IGVPorcentaje": 0.0,
                    "ImporteTotal": 100.000000,
                    "Kit": true,
                    "PrecioCompra": 0.000000,
                    "PrecioCompra_Base": 0.00000000,
                    "PrecioCompraUSD": 0.000000,
                    "PrecioCompra_BaseUSD": 0.00000000,
                    "Importado": false,
                    "CodigoCategoria": 0,
                    "Peso": 1.000000,
                    "Peso_Base": 0.0,
                    "PesoTotal": 0.000000,
                    "Control": 0,
                    "PrecioCodigo": 0,
                    "Stock": 0.000000,
                    "Vendedor": 0,
                    "ListaSeries": [],
                    "ListaPrecios": [
                        {
                            "PrecioId": -1,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "Prod00000",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.0,
                            "MonedaCodigo": "PEN",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.0,
                            "MargenPorcentaje": 0.0,
                            "PrecioVenta": 100.000000,
                            "Sugerido": 0.0,
                            "OtrosCargosPorcentaje": 0.0,
                            "CantidadAplicable": 0.0,
                            "FechaIngreso": "29/01/2024",
                            "FechaActualizacion": "29/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.0,
                            "ISCCalculado": 0.0
                        },
                        {
                            "PrecioId": -2,
                            "PrecioConfiguracion": 1,
                            "ProductoCodigo": "Prod00000",
                            "CodigoUnidadMedida": "NIU",
                            "DescripcionUnidadMedida": "UNIDAD",
                            "CantidadUnidadMedida": 1.0,
                            "MonedaCodigo": "USD",
                            "SucursalId": 3691,
                            "MargenGanancia": 0.0,
                            "MargenPorcentaje": 0.0,
                            "PrecioVenta": 100.000000,
                            "Sugerido": 0.0,
                            "OtrosCargosPorcentaje": 0.0,
                            "CantidadAplicable": 0.0,
                            "FechaIngreso": "29/01/2024",
                            "FechaActualizacion": "29/01/2024",
                            "Estado": "1",
                            "ISCPorcentaje": 0.0,
                            "ISCCalculado": 0.0
                        }
                    ]
                }
            ],
            "ListaAnticipos": [],
            "ListaCuotas": [],
            "ListaGuias": [],
            "ListaMovimientos": [
                {
                    "IdMovimiento": 94382,
                    "TipoCuentaCodigo": 1,
                    "CuentaNumero": "41414141",
                    "CuentaNombre": "NURIA",
                    "TipoIngresoEgreso": 1,
                    "MontoPagar": 100.000000,
                    "MonedaCodigo": "PEN",
                    "Observacion": "INGRESO VENTAS",
                    "NumeroOperacion": "",
                    "TipoDocIdentidadCodigo": "6",
                    "NumeroDocIdentidad": "10455897012",
                    "Origen": "VENTAS",
                    "TipoDocumentoCodigo": "08",
                    "Serie": "FD02",
                    "Correlativo": 31,
                    "Usuario": "41414141",
                    "IdOrigen": 1,
                    "Estado": 1,
                    "FechaPago": "08/01/2024",
                    "SucursalId": 3691,
                    "Pago": 100.000000,
                    "Pagado": 0.000000,
                    "Saldo": 0.000000,
                    "FechaVencimiento": "01/01/1900",
                    "PlazoDias": 0,
                    "CondicionComprobante": "Contado",
                    "Condicion": "Contado",
                    "Vuelto": 0.0,
                    "CondicionPagoModificado": "",
                    "CuentaNumeroModificado": "",
                    "CuentaTipoModificado": "",
                    "FechaMovimiento": ""
                }
            ],
            "ListaDocumentosRelacionados": [
                {
                    "ID": 0,
                    "Relacion": 3069,
                    "TipoDocumentoCodigo": "01",
                    "Serie": "F002",
                    "Correlativo": 10444,
                    "FechaEmision": "2024-01-08T00:00:00",
                    "Moneda": "PEN",
                    "Importe": 200.000000,
                    "UsuarioNombre": "NURIA",
                    "IDPadre": "",
                    "PDF": "2hfk0sOmtfOZkyCMWQM9ig==",
                    "Baja": false
                }
            ],
            "ListaCondicionesComerciales": null
        }
        `;
    const rows = [
        createData('Id', "long", "82857", t('content.recuperar.descripcionId')),
        createData('TipoDocumento', "String", "01", t('content.recuperar.descripcionTipoDocumento')),
        createData('Serie', "String", "F001", t('content.recuperar.descripcionSerie')),
        createData('Correlativo', "Int", "1234", t('content.recuperar.descripcionCorrelativo')),
        createData('Detalles', "Int", "1", t('content.recuperar.descripcionDetalles')),
        createData('Adicionales', "Int", "1", t('content.recuperar.descripcionAdicionales')),
        createData('Movimientos', "Int", "0", t('content.recuperar.descripcionMovimientos'))
    ];
    return (
        <div id="recover">
            <Divider sx={{ height: '70px' }} />
            <Typography variant="h3" id="recuperarComprobante" gutterBottom>
                {t('content.recuperar.titulo')}
            </Typography>
            <Typography variant="h5" gutterBottom>
                {t('content.recuperar.subtitulo')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.recuperar.descripcion')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.recuperar.descripcion2')}
            </Typography>
            <EndpointContent method={'GET'} path='https://wsventas-exp.rapifac.com/v0/comprobantes'/>
            <TabLenguaje curl={cCurl} csRS={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} ></TabLenguaje>
            {/*<CodeContent code={code} />*/}
            <br id={"recuperarObjeto"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.recuperar.subtituloRespuesta')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.recuperar.descripcion3')}
            </Typography>
            {/*<CodeContent code={codeResponse} languajeCode='json' />*/}
            <TablaTipoComprobante Factura={codeResponseFactura} NombreFactura={t('content.factura.titulo')} Boleta={codeResponseBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={codeResponseNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={codeResponseNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante>

            <br id={"recuperarDescripcion"}/>
            <br/>
        </div>
    )
}
export default Recover;